import http from 'http/index';

import { formatJobStatus } from './formatter';

export const getJobStatus = ({ tenantId }) => http.get(`/admin/tenants/${tenantId}/jobs.json`).then((res) => formatJobStatus(res.data));

export default getJobStatus;
